import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Flame, Heart, AlertTriangle, Snowflake } from 'lucide-react';

const META = {
  champion: { color: 'bg-emerald-100 text-emerald-800', icon: Flame,       label: 'Champion' },
  engaged:  { color: 'bg-blue-100 text-blue-800',       icon: Heart,       label: 'Engaged' },
  at_risk:  { color: 'bg-amber-100 text-amber-800',     icon: AlertTriangle, label: 'At risk' },
  cold:     { color: 'bg-gray-100 text-gray-600',       icon: Snowflake,   label: 'Cold' },
};

export function EngagementBadge({ score, bucket, showScore = false, size = 'sm' }) {
  if (score == null && !bucket) return null;
  const b = bucket || (score >= 80 ? 'champion' : score >= 60 ? 'engaged' : score >= 30 ? 'at_risk' : 'cold');
  const m = META[b] || META.cold;
  const Icon = m.icon;
  const sizing = size === 'lg' ? 'text-sm py-1 px-2.5' : 'text-[10px] py-0.5 px-1.5';
  return (
    <Badge className={`${m.color} border-0 ${sizing}`} data-testid={`engagement-badge-${b}`} title={`Engagement score: ${score ?? '-'} / 100`}>
      <Icon className={`${size === 'lg' ? 'h-3.5 w-3.5' : 'h-2.5 w-2.5'} mr-0.5`} />
      {m.label}{showScore && score != null ? ` · ${score}` : ''}
    </Badge>
  );
}

export function EngagementBreakdown({ detail }) {
  if (!detail) return null;
  const rows = [
    ['Recency',     detail.recency,     30, `Last gift ${detail.days_since_last_gift ?? '—'} days ago`],
    ['Frequency',   detail.frequency,   25, `${detail.gifts_24mo ?? 0} gifts in last 24 months`],
    ['Trend',       detail.trend,       25, `$${(detail.this_year_total || 0).toLocaleString()} this year vs $${(detail.prev_year_total || 0).toLocaleString()} last`],
    ['Touchpoints', detail.touchpoints, 20, `${detail.touchpoint_events_6mo ?? 0} activity events in last 6 months`],
  ];
  return (
    <div className="grid grid-cols-2 gap-2 text-xs" data-testid="engagement-breakdown">
      {rows.map(([label, val, max, hint]) => (
        <div key={label} className="border rounded p-2">
          <div className="flex justify-between font-medium">
            <span>{label}</span>
            <span className="tabular-nums">{val}/{max}</span>
          </div>
          <div className="h-1 bg-gray-200 rounded mt-1 overflow-hidden">
            <div className="h-full bg-[#6B3FA0]" style={{ width: `${(val / max) * 100}%` }} />
          </div>
          <div className="text-gray-500 mt-1 text-[10px]">{hint}</div>
        </div>
      ))}
    </div>
  );
}
